import React, { useMemo } from 'react';
import { addDevidersToString } from './helper-functions';

const OrderByCardTable = ({ valueData }) => {
    /* итоговые значения */
    const totals = useMemo(
        () =>
            valueData.reduce(
                (acc, i) => ({
                    count:   acc.count  + (i.ordersCount        || 0),
                    amount:  acc.amount + (i.totalAmount        || 0),
                    profit:  acc.profit + (i.totalTraderProfit   || 0)
                }),
                { count: 0, amount: 0, profit: 0 }
            ),
        [valueData]
    );

    return (
        <div style={{overflowX: 'auto', width: '100%' }}>
        <table className="transaction-table">
            <thead>
            <tr>
                <th>Период</th>
                <th>Карта</th>
                <th>Банк</th>
                <th>Количество</th>
                <th>Оборот [₽]</th>
                <th>Профит [USDT]</th>
            </tr>
            </thead>

            <tbody>
            {valueData.map((item, idx) => (
                <tr key={item.cardId} className={idx % 2 ? 'odd-row' : 'even-row'}>
                    <td>
                        {new Date(item.startDate).toLocaleDateString('ru-RU')} –{' '}
                        {new Date(item.stopDate).toLocaleDateString('ru-RU')}
                    </td>
                    <td>
                        {item.cardholder} • {String(item.number).slice(-4)}
                    </td>
                    <td>{item.bank}</td>
                    <td>{item.ordersCount}</td>
                    <td>{addDevidersToString(item.totalAmount.toFixed(2))}</td>
                    <td>{addDevidersToString(item.totalTraderProfit.toFixed(2))}</td>
                </tr>
            ))}
            </tbody>

            <tfoot>
            <tr className="day-row">
                <td colSpan={3} style={{ textAlign: 'right', fontWeight: 600 }}>
                    ТОТАЛ
                </td>
                <td>{totals.count}</td>
                <td>{addDevidersToString(totals.amount.toFixed(2))}</td>
                <td>{addDevidersToString(totals.profit.toFixed(2))}</td>
            </tr>
            </tfoot>
        </table>
        </div>
    );
};

export default OrderByCardTable;
